import { render, staticRenderFns } from "./new_renew.vue?vue&type=template&id=7f87f438&scoped=true&"
import script from "./new_renew.vue?vue&type=script&lang=tsx&"
export * from "./new_renew.vue?vue&type=script&lang=tsx&"
import style0 from "./new_renew.vue?vue&type=style&index=0&id=7f87f438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87f438",
  null
  
)

export default component.exports